import { HttpStatusCode, isAxiosError } from 'axios'

export function isNotFoundError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === HttpStatusCode.NotFound
}
